// extracted by mini-css-extract-plugin
module.exports = {"light-mode":"WrongNetwork_light-mode__3HESg","wrong":"WrongNetwork_wrong__wIUQ-","statusIcon":"WrongNetwork_statusIcon__A3AcY","btnGroup":"WrongNetwork_btnGroup__16SSC"};